import { Colors } from '@blueprintjs/core'
import { CSSProperties } from 'react'

export const CategoryRowStyle: CSSProperties = {
  padding: '5px 10px 5px 5px',
  display: 'flex',
  cursor: 'pointer'
}

export const TerminalCategoryRowStyle: CSSProperties = {
  ...CategoryRowStyle,
  cursor: 'default'
}

export const CategoryRowStyleHighlighted: CSSProperties = {
  ...CategoryRowStyle,
  backgroundColor: Colors.LIGHT_GRAY4,
  color: Colors.COBALT1
}

export const CategoryRowIconStyle: CSSProperties = { flex: '1 0 auto', textAlign: 'right', pointerEvents: 'none' }

export const CategoryMultiselectStyle: CSSProperties = {
  display: 'flex',
  height: '100%',
  overflow: 'scroll hidden'
}

export const CategoryMultiselectContainerStyle: CSSProperties = {
  border: `1px solid ${Colors.GRAY5}`,
  borderRadius: 2
}

export const CategoryMultiselectBodyStyle: CSSProperties = {
  backgroundColor: Colors.LIGHT_GRAY5,
  position: 'relative',
  height: 200
}

export const LightTextStyle: CSSProperties = {
  color: Colors.DARK_GRAY1
}

export const CategoryMultiselectFooterStyle: CSSProperties = {
  display: 'flex',
  fontSize: '0.8em',
  backgroundColor: Colors.LIGHT_GRAY5,
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTop: `1px solid ${Colors.LIGHT_GRAY2}`
}

export const CategorySearchStyle: CSSProperties = {
  borderBottom: `1px solid ${Colors.GRAY5}`
}

export const CategorySearchOverlayStyle: CSSProperties = {
  position: 'absolute',
  zIndex: 10,
  backgroundColor: Colors.LIGHT_GRAY5,
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  overflow: 'hidden scroll'
}

export const CategorySearchOverlayHeadingStyle: CSSProperties = {
  position: 'sticky',
  top: 0,
  backgroundColor: Colors.LIGHT_GRAY5,
  padding: 10,
  margin: 0
}

export const CategoryColumnStyle: CSSProperties = {
  height: '100%',
  maxHeight: '100%',
  overflow: 'hidden scroll',
  backgroundColor: Colors.WHITE,
  borderRight: `solid 1px ${Colors.LIGHT_GRAY4}`,
  minWidth: 200
}

export const CategoryMultiselectLoadingOverlayStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center'
}

export const CategoryListContainerStyle: CSSProperties = {
  maxHeight: 100,
  overflow: 'hidden scroll'
}

export const CategoryListStyle: CSSProperties = {
  color: Colors.GRAY1,
  fontStyle: 'italic',
  padding: '10px 5px 5px',
  margin: 0,
  fontSize: '0.8em'
}
